import React, { useEffect, useRef } from 'react'

export default ({listener, ignoreParentClick}) => {
    const ref = useRef(null);

    const _listener = React.useCallback((e) => {
        if(!ignoreParentClick || (ref.current && ref.current.parentNode && !ref.current.parentNode.contains(e.target))){
            listener(e);
        }
    }, [listener, ignoreParentClick, ref]);

    useEffect(() => {
        document.body.addEventListener('click', _listener);
        return () => {
            document.body.removeEventListener('click', _listener);
        };
    }, [_listener]);

    return <div ref={ref} style={{display: "none"}}/>
}